import React, { Component, useRef } from "react";
import {
  AddressInfo,
  ConnectorType,
  Coordinates,
  ProviderConsts,
} from "../../entities/iconData";
import station_2_icon from "../../assets/images/station_2_icon.png";
import busy_station_icon from "../../assets/images/busy_station_icon.png";
import unknown_station_icon from "../../assets/images/unknown_status_icon.png";
import inactive_station_icon from "../../assets/images/inactive_station_icon.png";
import comingSoon_station_icon from "../../assets/images/comingSoon_station_icon.png";
import InfoPopup from "../InfoPopup/InfoPopup";
import afkon from "../../assets/Providers/ev-on.png";
import charge from "../../assets/Providers/charge.png";
import greenspot from "../../assets/Providers/greenspot.png";
import sonol from "../../assets/Providers/sonol.png";
import netzer from "../../assets/Providers/netzer.png";
import Ev4u from "../../assets/Providers/ev4u.png";
import EdgeControl from "../../assets/Providers/edge-control.png";
import ScalaEv from "../../assets/Providers/scalaev.png";
import ViMore from "../../assets/Providers/vimore.png";
import Nofar from "../../assets/Providers/nofar.png";
import Greems from "../../assets/Providers/greems.png";
import TDSD from "../../assets/Providers/tdsd.png";
import SevenEv from "../../assets/Providers/sevenev.png";
import Doralurban from "../../assets/Providers/doral-urban.png";
import Lishatech from "../../assets/Providers/lishatech.png";

import ZenEv from "../../assets/Providers/zenev.png";
import Enova from "../../assets/Providers/enova.png";
import InterEv from "../../assets/Providers/interev.png";

import EvPlus from "../../assets/Providers/ev-plus.png";
import AmisraGreen from "../../assets/Providers/amisragreen.png";
import Advice from "../../assets/Providers/advice.png";
import EvTech from "../../assets/Providers/evtech.png";

import info_icon from "../../assets/images/info_icon.png";
import gnrgy from "../../assets/operator_logo/Gnrgy.png";
import evedge from "../../assets/operator_logo/EvEgde_Logo.png";
import evcharge from "../../assets/operator_logo/EVCharge_Logo.png";
import go_to_icon from "../../assets/images/go_to_icon.png";
import Tooltip from "@material-ui/core/Tooltip";
import { withStyles, Theme } from "@material-ui/core/styles";
import "./IconMap.scss";
import CloseIcon from "@material-ui/icons/Close";
import { BrowserLanguage } from "../../entities/BrowserLanguage";
import { LayersFilters } from "../../entities/LayersFilters";
import { StringsData } from "../../entities/StringsData";
import { type } from "os";
import gmap from "../../assets/images/google-maps-icon.svg.png";
import wazeIcon from "../../assets/images/waze-icon.png";

import { ReactComponent as Type_2_img } from "../../assets/Sockets/type_2_icon.svg";
import { ReactComponent as Combo_icon } from "../../assets/Sockets/combo_icon.svg";
import { ReactComponent as Phase_icon } from "../../assets/Sockets/phase_icon.svg";
import { ReactComponent as Schuko_icon } from "../../assets/Sockets/schuko_icon.svg";
import { MoreInfoData, StationConnector } from "../../entities/MoreInfoData";
import { Box, Tab, Tabs } from "@material-ui/core";
import { TabContext, TabPanel } from "@material-ui/lab";
import MoreInfo from "../MoreInfo/MoreInfo";
import he from "../../locals/he.json";
import en from "../../locals/en.json";
import ar from "../../locals/ar.json";
import ru from "../../locals/ru.json";

const locals: Record<string, any> = {
  he,
  en,
  ar,
  ru,
};

const paymentTranslations: Record<string, Record<string, string>> = {
  en: {
    CHARGING_PROFILE_CAPABLE: "Charging profiles",
    REMOTE_START_STOP_CAPABLE: "Third-party service",
    CHIP_CARD_SUPPORT: "Chip Card",
    CONTACTLESS_CARD_SUPPORT: "Payment app",
    CREDIT_CARD_PAYABLE: "Credit Card",
    DEBIT_CARD_PAYABLE: "Debit Card",
    RFID_READER: "Dedicated card",
  },
  he: {
    CHARGING_PROFILE_CAPABLE: "תומך בפרופילי טעינה",
    REMOTE_START_STOP_CAPABLE: "שירות צד ג'",
    CHIP_CARD_SUPPORT: "כרטיס שבב",
    CONTACTLESS_CARD_SUPPORT: "אפליקציית תשלום",
    CREDIT_CARD_PAYABLE: "כרטיס אשראי",
    DEBIT_CARD_PAYABLE: "כרטיס חיוב",
    RFID_READER: "כרטיס ייעודי",
  },
  ar: {
    CHARGING_PROFILE_CAPABLE: "دعم ملفات الشحن",
    REMOTE_START_STOP_CAPABLE: "خدمة جهة خارجية",
    CHIP_CARD_SUPPORT: "بطاقة ذكية",
    CONTACTLESS_CARD_SUPPORT: "تطبيق دفع",
    CREDIT_CARD_PAYABLE: "بطاقة ائتمان",
    DEBIT_CARD_PAYABLE: "بطاقة خصم",
    RFID_READER: "بطاقة مخصصة",
  },
  ru: {
    CHARGING_PROFILE_CAPABLE: "Профили зарядки",
    REMOTE_START_STOP_CAPABLE: "Сервис третьей стороны",
    CHIP_CARD_SUPPORT: "Чип-карта",
    CONTACTLESS_CARD_SUPPORT: "Приложение для оплаты",
    CREDIT_CARD_PAYABLE: "Кредитная карта",
    DEBIT_CARD_PAYABLE: "Дебетовая карта",
    RFID_READER: "Специальная карта",
  },
};

const popup = "popup";
const tooltip = "tooltip";

class IconMap extends Component<IconMapProps, IconMapState> {
  private lastFocusedElement: HTMLElement | null = null;
  stationHeadingRef: React.RefObject<HTMLSpanElement> = React.createRef();

  extractConnectorNumbers(text: string): string[] {
    let pattern: RegExp;

    switch (this.props.browserLanguage) {
      case BrowserLanguage.he:
        pattern = /מחבר\s+([\d.]+)/g;
        break;
      case BrowserLanguage.en:
        pattern = /Connector\s+([\d.]+)/g;
        break;
      case BrowserLanguage.ru:
        pattern = /Соединитель\s+([\d.]+)/g;
        break;
      case BrowserLanguage.ar:
        pattern = /موصل\s+([\d.]+)/g;
        break;
      default:
        pattern = /מחבר\s+([\d.]+)/g;
    }

    const matches: string[] = [];
    let match;
    while ((match = pattern.exec(text)) !== null) {
      matches.push(match[1]);
    }
    return matches;
  }

  getKwSuffix(): string {
    switch (this.props.browserLanguage) {
      case BrowserLanguage.he:
        return 'קוט"ש';
      case BrowserLanguage.en:
        return "kW";
      case BrowserLanguage.ru:
        return "кВт";
      case BrowserLanguage.ar:
        return "كيلوواط";
      default:
        return 'קוט"ש';
    }
  }

  getLocaleString(key: string): string {
    const lang = this.props.browserLanguage
      .toString()
      .toLowerCase()
      .slice(0, 2);
    const selectedLocale = locals[lang] || locals["he"];
    return selectedLocale[key] || "";
  }

  getStationLang = (name: string): string => {
    if (!name) return "he";
    const firstChar = name.trim().charAt(0);
    const isHebrew = /^[\u0590-\u05FF]/.test(firstChar);
    return isHebrew ? "he" : "en";
  };

  infoIconRef: React.RefObject<HTMLButtonElement> = React.createRef();

  replaceDollarSymbolWithShekel(text: string): string {
    return text.replace(/\$/g, "₪");
  }

  getTextAlign(): "left" | "right" {
    return this.getTextDir() === "rtl" ? "right" : "left";
  }

  handleTabLoop = (e: KeyboardEvent) => {
    if (!this.state.open || !this.popupRef.current) return;

    const focusableElements =
      this.popupRef.current.querySelectorAll<HTMLElement>(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );

    if (focusableElements.length === 0) return;

    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    if (e.key === "Tab") {
      if (e.shiftKey) {
        if (document.activeElement === firstElement) {
          e.preventDefault();
          lastElement.focus();
        }
      } else {
        if (document.activeElement === lastElement) {
          e.preventDefault();
          firstElement.focus();
        }
      }
    }
  };
  firstFocusableRef: React.RefObject<HTMLSpanElement> = React.createRef();
  lastFocusableRef: React.RefObject<HTMLButtonElement> = React.createRef();

  getGeneralTabLabel(): string {
    switch (this.props.browserLanguage) {
      case BrowserLanguage.en:
        return "General";
      case BrowserLanguage.ru:
        return "Общее";
      case BrowserLanguage.ar:
        return "عام";
      case BrowserLanguage.he:
      default:
        return "כללי";
    }
  }

  getPaymentMethodsText(paymentTypesArr?: string[]): string {
    const { browserLanguage } = this.props;

    if (!paymentTypesArr || paymentTypesArr.length === 0) {
      return browserLanguage === BrowserLanguage.he
        ? " לא זמין"
        : " Not available";
    }

    const lang = browserLanguage.toString().toLowerCase().slice(0, 2);
    const translations = paymentTranslations[lang] || {};

    const translated = paymentTypesArr.map((type) => {
      const key = type.trim().toUpperCase(); // normalize to match our map
      return translations[key] || key;
    });

    return translated.join(", ");
  }

  getTariffTabLabel(): string {
    switch (this.props.browserLanguage) {
      case BrowserLanguage.en:
        return "Tariffs";
      case BrowserLanguage.ru:
        return "Тарифы";
      case BrowserLanguage.ar:
        return "الأسعار";
      case BrowserLanguage.he:
      default:
        return "תעריפים";
    }
  }

  private popupRef: React.RefObject<HTMLDivElement> =
    React.createRef<HTMLDivElement>();

  constructor(props: IconMapProps) {
    super(props);
    this.state = {
      open: false,
      tooltipType: tooltip,
      portalView: false,
      tabValue: "0",
      showMoreInfoPopup: () => {},
    };
  }

  getTariffHeaderText(): string {
    switch (this.props.browserLanguage) {
      case BrowserLanguage.en:
        return "The price   estimate is based on the 'normalized cost per kWh' derived from the   assumption that the vehicle will charge approximately 22 kWh during the   charging session. The price factors in the costs over the period of time   required to charge 22 kWh, a period that varies depending on the station's   power output. For more information, please refer to the Terms of Use   document. The calculation is based on the cheapest station at the site - not   necessarily the available station.";
      case BrowserLanguage.he:
        return `אומדן המחירים מתבסס על "עלות מנורמלת לקוט"ש אחד"   הנגזרת מההנחה שהרכב יטען כ-22 קוט"ש במהלך הטעינה. המחיר משקלל את העלויות   בפרק הזמן שיידרש לטעינת 22 קוט"ש, פרק זמן זה משתנה כתלות בהספק העמדה.   להרחבה פנו למסמך תנאי השימוש.
     החישוב מתבצע על בסיס העמדה הזולה באתר – לא בהכרח העמדה הפנויה. `;
      case BrowserLanguage.ru:
        return `Оценка цен   основана на 'нормализованной стоимости за кВтч', которая исходит из   предположения, что автомобиль зарядит около 22 кВтч в течение зарядной   сессии. Цена учитывает затраты за период времени, необходимый для зарядки 22   кВтч, этот период варьируется в зависимости от мощности станции. Для   получения дополнительной информации обратитесь к документу Условия   использования. Расчет производится на основе самой дешевой станции на объекте   - не обязательно доступной станции.`;
      case BrowserLanguage.ar:
        return "يستند تقدير   السعر على 'التكلفة المعيارية لكيلوواط ساعة واحد' المشتقة من افتراض أن السيارة   ستشحن حوالي 22 كيلوواط ساعة خلال جلسة الشحن. يأخذ السعر في الاعتبار التكاليف   خلال الفترة الزمنية اللازمة لشحن 22 كيلوواط ساعة، وهي فترة تختلف حسب قدرة   المحطة. لمزيد من المعلومات، يرجى الرجوع إلى وثيقة شروط الاستخدام. يتم إجراء   الحساب على أساس أرخص محطة في الموقع - وليس بالضرورة المحطة المتاحة.";
      default:
        return "";
    }
  }
  getTariffFooterText(): string {
    switch (this.props.browserLanguage) {
      case BrowserLanguage.en:
        return "This calculation is   based on information provided by charging station operators. The app and its   operators have no ability or responsibility to verify data accuracy. If you   find an error, please contact the operator to update the information and   notify the database operator and the Ministry of Energy through the data   reliability issue reporting form.";
      case BrowserLanguage.he:
        return 'החישוב הנ"ל מתבסס על המידע המועבר ממפעילי עמדות הטעינה ואין   לאפליקציה ומפעיליה יכולת או אחריות לוודא את אמינות הנתונים. במידה ומצאתם   שגיאה נבקשכם לפנות למפעיל בדרישה לעדכן את המידע וכן לעדכן את מפעילת מאגר   המידע ומשרד האנרגיה באמצעות טופס הפניות לדיווח תקלה באמינות הנתונים.';
      case BrowserLanguage.ru:
        return "Этот расчет основан на   информации, предоставленной операторами зарядных станций. Приложение и его   операторы не имеют возможности или ответственности проверять точность данных.   Если вы обнаружили ошибку, пожалуйста, свяжитесь с оператором для обновления   информации и уведомите оператора базы данных и Министерство энергетики через   форму сообщения о проблеме достоверности данных.";
      case BrowserLanguage.ar:
        return "يعتمد هذا الحساب على   المعلومات المقدمة من مشغلي محطات الشحن. ليس للتطبيق ومشغليه القدرة أو   المسؤولية للتحقق من دقة البيانات. إذا وجدت خطأ، يرجى الاتصال بالمشغل لتحديث   المعلومات وإبلاغ مشغل قاعدة البيانات ووزارة الطاقة من خلال نموذج الإبلاغ عن   مشكلة موثوقية البيانات.";
      default:
        return "";
    }
  }

  getTariffSecondaryText(): string {
    switch (this.props.browserLanguage) {
      case BrowserLanguage.en:
        return "The displayed price is an estimated average for charging a vehicle per 1 kWh";
      case BrowserLanguage.he:
        return 'המחירים המוצגים הינם חישוב ממוצע מוערך לעמדת טעינה ביחידות כמות 1 קוט"ש';
      case BrowserLanguage.ru:
        return "Отображаемая цена является оценочным средним значением для зарядки автомобиля за 1 кВт⋅ч";
      case BrowserLanguage.ar:
        return "السعر المعروض هو متوسط تقديري لشحن السيارة لكل كيلووات ساعة";
      default:
        return 'המחירים המוצגים הינם חישוב ממוצע מוערך לעמדת טעינה ביחידות כמות 1 קוט"ש';
    }
  }

  getPriceInfoText(): string {
    const { moreInfoData, addressInfo, browserLanguage } = this.props;

    const price = addressInfo?.price;
    if (price !== undefined && price !== null) {
      const value = price.toFixed(2);
      switch (browserLanguage) {
        case BrowserLanguage.en:
          return `₪${value} per kWh`;
        case BrowserLanguage.ru:
          return `₪${value} за кВт⋅ч`;
        case BrowserLanguage.ar:
          return `₪${value} لكل كيلووات ساعة`;
        case BrowserLanguage.he:
        default:
          return `₪${value} קו״טש`;
      }
    }

    const description = moreInfoData?.tariffDescription || "";

    const shekelRegex = /(?:start fee\s*)?([\d.]+)\s*₪(?: לפי קוט"ש)?/gi;
    const shekelMatches = Array.from(description.matchAll(shekelRegex));

    if (shekelMatches.length > 0) {
      const maxPrice = Math.max(...shekelMatches.map((m) => parseFloat(m[1])));
      const value = maxPrice.toFixed(2);
      switch (browserLanguage) {
        case BrowserLanguage.en:
          return `₪${value} per kWh`;
        case BrowserLanguage.ru:
          return `₪${value} за кВт⋅ч`;
        case BrowserLanguage.ar:
          return `₪${value} لكل كيلووات ساعة`;
        case BrowserLanguage.he:
        default:
          return `₪${value} קו״טש`;
      }
    }

    switch (browserLanguage) {
      case BrowserLanguage.en:
        return "Tariff not available";
      case BrowserLanguage.ru:
        return "Нет данных о тарифах";
      case BrowserLanguage.ar:
        return "لا توجد معلومات عن السعر";
      case BrowserLanguage.he:
      default:
        return "אין מידע על התעריף";
    }
  }

  getNoInfoText(): string {
    switch (this.props.browserLanguage) {
      case BrowserLanguage.en:
        return "No information available";
      case BrowserLanguage.he:
        return "אין מידע";
      case BrowserLanguage.ru:
        return "Нет информации";
      case BrowserLanguage.ar:
        return "لا توجد معلومات";
      default:
        return "אין מידע";
    }
  }

  getTextDir(): string {
    switch (this.props.browserLanguage) {
      case BrowserLanguage.en:
        return "ltr";
      case BrowserLanguage.ru:
        return "ltr";
      case BrowserLanguage.ar:
        return "rtl";
      case BrowserLanguage.he:
        return "rtl";
      default:
        return "rtl";
    }
  }

  render() {
    const { addressInfo, stringsFromServer, providersArr } = this.props;
    const uniqid = Math.random().toString(16).slice(2);
    if (this.state.tooltipType === tooltip) {
      return (
        <div className="tooltip" key={addressInfo.id}>
          <this.LightTooltip
            placement="top"
            arrow
            title={<div className="tooltip-label">{addressInfo.name}</div>}
          >
            <img
              ref={(el) => (this.lastFocusedElement = el)}
              className="location-map"
              src={this.getCorrectStationIcon()}
              alt="station icon"
              onClick={this.clickIcon}
              tabIndex={20}
              id={uniqid}
              onKeyDown={(e) => {
                e?.key == "Enter" &&
                  document.getElementById(uniqid)?.click() &&
                  this.popupRef.current?.focus();
              }}
            ></img>
          </this.LightTooltip>
        </div>
      );
    }
    return (
      <>
        <div>
          <this.LightTooltip
            placement="top"
            interactive
            tabIndex={19}
            id="main-icon-popup"
            arrow
            TransitionProps={{
              onEntered: () => {
                const heading = document.getElementById("popup-heading");
                if (heading) {
                  heading.focus();
                  setTimeout(() => {
                    this.firstFocusableRef.current?.focus();
                  }, 500);
                }
              },
            }}
            title={
              <div
                className={`popup-icon ${this.props.browserLanguage}`}
                tabIndex={19}
                ref={this.popupRef}
                role="dialog"
                aria-modal="true"
                aria-labelledby="popup-heading"
              >
                <div id="popup-desc" hidden>
                  <div
                    dir={this.getTextDir()}
                    style={{ textAlign: this.getTextAlign() }}
                  >
                    {this.getTariffSecondaryText()}
                  </div>
                  <div
                    dir={this.getTextDir()}
                    style={{ textAlign: this.getTextAlign() }}
                  >
                    {this.getTariffHeaderText()}
                  </div>
                  <div
                    dir={this.getTextDir()}
                    style={{ textAlign: this.getTextAlign() }}
                  >
                    {this.getTariffFooterText()}
                  </div>
                </div>

                <div className="img-popup-icon">
                  <span
                    className="close-icon"
                    aria-label="סגור"
                    ref={this.firstFocusableRef}
                    tabIndex={19}
                    onClick={this.handleTooltipClose}
                    onKeyDown={(e) => {
                      e?.key == "Enter" && this.handleTooltipClose();
                    }}
                    role="button"
                  >
                    <CloseIcon />
                  </span>
                </div>
                <Box sx={{ width: "100%" }}>
                  <TabContext value="0">
                    <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                      <Tabs
                        value={this.state.tabValue}
                        onChange={this.InfoTabValueChanged}
                        aria-label="station info tabs"
                      >
                        <Tab
                          id="0"
                          value={"0"}
                          label={this.getGeneralTabLabel()}
                          aria-label="כללי"
                          key="0"
                          tabIndex={19}
                        />
                        <Tab
                          id="1"
                          value={"1"}
                          label={this.getTariffTabLabel()}
                          aria-label="מידע על תעריפים"
                          key="1"
                          tabIndex={19}
                        />
                      </Tabs>
                    </Box>
                    <TabPanel value={this.state.tabValue} key={"0"}>
                      <div className="go-to">
                        <img
                          src={wazeIcon}
                          alt="waze icon"
                          aria-label="וייז"
                          onKeyDown={(e) => {
                            e?.key == "Enter" &&
                              this.wazeNavigation(addressInfo);
                          }}
                          tabIndex={19}
                          onClick={() => this.wazeNavigation(addressInfo)}
                        />
                        <img
                          src={gmap}
                          onKeyDown={(e) => {
                            e?.key == "Enter" &&
                              this.googleMapsNavigation(addressInfo);
                          }}
                          tabIndex={19}
                          alt="google maps icon"
                          aria-label="גוגל מפות"
                          onClick={() => this.googleMapsNavigation(addressInfo)}
                        />
                      </div>
                      <div className="provider-logo">
                        <img
                          className="img-provider"
                          src={
                            providersArr?.filter(
                              (e) => e?.id == addressInfo.provID
                            )?.[0]?.imageUrl
                          }
                          alt=""
                        />
                      </div>

                      <div className="name">
                        <span className="label">
                          <a href="#">
                            <button
                              tabIndex={19}
                              className="info-btn"
                              title="מידע נוסף"
                              aria-label="מידע נוסף"
                              aria-labelledby="popup-heading"
                              onClick={this.props.showMoreInfoPopup}
                              onKeyDown={(e) =>
                                e.key == "Enter" &&
                                this.props.showMoreInfoPopup()
                              }
                              ref={this.infoIconRef}
                            >
                              <svg
                                width="16"
                                height="17"
                                viewBox="0 0 16 17"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M16 8.84766C16 13.2659 12.4183 16.8477 8 16.8477C3.58172 16.8477 0 13.2659 0 8.84766C0 4.42938 3.58172 0.847656 8 0.847656C12.4183 0.847656 16 4.42938 16 8.84766ZM6.66667 4.32552H8.66667V6.15161H6.66667V4.32552ZM8.66667 7.36979H6.66667V13.4567H8.66667V7.36979Z"
                                  fill="#1BB4BB"
                                />
                              </svg>
                            </button>
                          </a>
                          &nbsp;
                          <span
                            id="popup-heading"
                            tabIndex={-1}
                            lang={this.getStationLang(addressInfo.name)}
                          >
                            {this.getStationName(addressInfo.name)}
                          </span>
                        </span>
                      </div>

                      {/* <hr></hr> */}
                      <div className="street">
                        <div className="address-label">
                          {/*  {stringsFromServer.site_StationInfoAddress}*/}
                        </div>
                        <div className="address-info-div">
                          {this.getStationName(addressInfo.streetName)}
                          {addressInfo.city ? `, ${addressInfo.city}` : ""}
                        </div>
                      </div>
                      <div className="payment-method">
                        <div className="address-info-div">
                          {this.getLocaleString("site_PaymentMethodsLabel")}
                          <br />
                          {this.getPaymentMethodsText(
                            addressInfo?.moreInfoStationData?.paymentTypesArr
                          )}
                        </div>
                      </div>
                      <div className="connector-num">
                        {(() => {
                          const stations =
                            addressInfo?.moreInfoStationData?.stations || [];
                          const counts: Record<
                            string,
                            {
                              total: number;
                              available: number;
                              powers: string[];
                            }
                          > = {};

                          stations.forEach((station) => {
                            const connector = station.connectors?.[0]?.standard;
                            const power =
                              station.connectors?.[0]?.maxPower?.toString() ||
                              "";
                            if (!connector) return;

                            if (!counts[connector]) {
                              counts[connector] = {
                                total: 0,
                                available: 0,
                                powers: [],
                              };
                            }

                            counts[connector].total += 1;
                            if (station.status === "AVAILABLE") {
                              counts[connector].available += 1;
                            }
                            if (power) {
                              counts[connector].powers.push(power);
                            }
                          });

                          return Object.entries(counts)
                            .slice(0, 5)
                            .map(
                              ([connector, { total, available, powers }]) => (
                                <div key={connector} className="power-num-img">
                                  <div>{this.getConnectorName(connector)}</div>
                                  <div className="connector-img">
                                    <span>
                                      {this.getConnectorImage(connector)}
                                      <label className="circle">
                                        {available}/{total}
                                      </label>
                                    </span>
                                  </div>
                                  <div className="power-info">
                                    {(() => {
                                      const uniquePowers = Array.from(
                                        new Set(powers.map(Number))
                                      );
                                      if (uniquePowers.length === 0)
                                        return null;

                                      const maxPower = Math.max(
                                        ...uniquePowers
                                      );

                                      return (
                                        <div>
                                          <span dir="ltr">
                                            {this.getKwSuffix()}: {maxPower}
                                          </span>
                                        </div>
                                      );
                                    })()}
                                  </div>
                                </div>
                              )
                            );
                        })()}

                        {this.props.moreInfoData?.tariffDescription && (
                          <div
                            className="tariff-description-text"
                            dir={this.getTextDir()}
                            style={{
                              marginTop: "20px",
                              textAlign: this.getTextAlign(),
                            }}
                          ></div>
                        )}
                      </div>
                    </TabPanel>
                  </TabContext>
                  <TabContext value="1">
                    <TabPanel value={this.state.tabValue} key={"1"}>
                      <div id="popup-desc" hidden>
                        {this.getTariffSecondaryText()}
                        {this.getTariffHeaderText()}
                        {this.getTariffFooterText()}
                      </div>
                      <div
                        className="tariff-info"
                        tabIndex={19}
                        dir={this.getTextDir()}
                        style={{ textAlign: this.getTextAlign() }}
                      >
                        <h3 dir={this.getTextDir()}>
                          {this.getPriceInfoText()}
                        </h3>
                        <div className="description" dir={this.getTextDir()}>
                          {this.getTariffSecondaryText()}
                        </div>
                        <div className="tariff-heading" dir={this.getTextDir()}>
                          <div className="description" dir={this.getTextDir()}>
                            {this.getTariffHeaderText()}
                          </div>
                        </div>
                        <span
                          className="tariff-info-span"
                          dir={this.getTextDir()}
                        >
                          {this.props.moreInfoData?.tariffDescription
                            ? this.replaceDollarSymbolWithShekel(
                                this.props.moreInfoData.tariffDescription
                              )
                            : this.getNoInfoText()}
                        </span>
                        <div className="tariff-heading" dir={this.getTextDir()}>
                          <div className="description" dir={this.getTextDir()}>
                            {this.getTariffFooterText()}
                          </div>
                        </div>
                      </div>
                    </TabPanel>
                  </TabContext>
                </Box>
                {/* 
                            <div className="chargers">
                               
                                 { (addressInfo.moreInfoStationData && (addressInfo.moreInfoStationData.fastConnectorCounter>0))?
                                    <span className='label' > <span className="circle"></span>
                                 {    ' DC - ' + addressInfo.moreInfoStationData.fastConnectorCounter } <br /></span>:''} 
                                   {/*{stringsFromServer.site_StationInfoFastCharge}*/}
                {/* { (addressInfo.moreInfoStationData && ((addressInfo.moreInfoStationData.connectorCounter - addressInfo.moreInfoStationData.fastConnectorCounter) >0))? 
                                     <span className='label'>
                                      <span className="circle"></span>
                                {' AC - ' + (addressInfo.moreInfoStationData.connectorCounter- addressInfo.moreInfoStationData.fastConnectorCounter)}</span> :''}  */}
                {/*{this.getRegularChargeConnectors(addressInfo)} {stringsFromServer.site_StationInfoRegularCharge}*/}
                {/* </div> */}
                {/* <div className="button">
                                <div className="more-info-button"
                                    onClick={() => this.props.getMoreInfoStation(addressInfo)}
                                >
                                    <img src={info_icon} alt="mor info icon" />
                                    <span className="label">{stringsFromServer.site_StationInfoMoreInfoTxt} </span>
                                </div>
                        
                            </div> */}
              </div>
            }
            onClose={this.handleTooltipClose}
            open={this.state.open}
            disableFocusListener
            disableHoverListener
            disableTouchListener
          >
            <img
              className="location-map-click"
              src={this.getCorrectStationIcon()}
              alt="station icon"
              onClick={this.clickIcon}
              tabIndex={20}
            ></img>
          </this.LightTooltip>
        </div>
      </>
    );
  }

  LightTooltip = withStyles((theme: Theme) => ({
    tooltip: {
      backgroundColor: theme.palette.common.white,
      color: "rgba(0, 0, 0, 0.87)",
      fontSize: 15,
      width: "auto",
      padding: "0",
      border: "1px solid #0071F2",
      borderRadius: "15px",
    },
  }))(Tooltip);

  componentDidMount() {
    const portal = window.location.search.includes("dashboard");
    this.setState({ portalView: portal });
    this.checkSelectedStation();

    document.addEventListener("keydown", this.handleTabLoop);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleTabLoop);
  }

  componentDidUpdate(prevProps: IconMapProps) {
    const { selectedStation, closeAllPopups } = this.props;
    if (
      selectedStation &&
      prevProps.selectedStation?.id !== selectedStation.id
    ) {
      this.checkSelectedStation();
      setTimeout(() => {
        this.firstFocusableRef.current?.focus();
      }, 50);
    }
    if (!selectedStation && closeAllPopups && this.state.open) {
      this.setState({ open: false, tooltipType: tooltip });
    }
  }

  getStationName = (name: string) => {
    return name;
  };

  checkSelectedStation = () => {
    const { addressInfo, selectedStation, closeAllPopups } = this.props;
    if (addressInfo.id === selectedStation?.id && !this.state.portalView) {
      this.setState({ open: true, tooltipType: popup });
      return;
    }
    if (closeAllPopups) {
      this.setState({ open: false, tooltipType: tooltip });
    }
  };

  handleTooltipClose = () => {
    this.setState({ open: false, tooltipType: tooltip }, () => {
      if (
        this.lastFocusedElement &&
        document.body.contains(this.lastFocusedElement)
      ) {
        this.lastFocusedElement.focus(); //
      }
    });
  };

  clickIcon = () => {
    this.lastFocusedElement = document.activeElement as HTMLElement;
    if (this.state.tooltipType === tooltip && !this.state.portalView) {
      this.setState({ open: true, tooltipType: popup }, () => {
        this.props.onClickStation(this.props.addressInfo);
        setTimeout(() => {
          this.popupRef.current?.focus();
        }, 0);
      });
      return;
    }

    setTimeout(() => {
      this.popupRef.current?.focus();
    }, 200);

    this.setState({ open: false, tooltipType: tooltip });
  };

  getRegularChargeConnectors = (addressInfo: AddressInfo) => {
    var cntr: number = 0;
    cntr = addressInfo.moreInfoStationData
      ? addressInfo.moreInfoStationData.connectorCounter -
        addressInfo.moreInfoStationData.fastConnectorCounter
      : 0;
    // addressInfo.moreInfoStationData?.connectorTypes?.filter(con=>con.power>=50).map(typ=>cntr++);
    return cntr;
  };

  getProviderImage = (providerId: number) => {
    const providerConsts = new ProviderConsts();

    switch (providerId) {
      case providerConsts.PROVIDER_AFKON: {
        return afkon;
      }
      case providerConsts.PROVIDER_GNRGY: {
        return gnrgy;
      }
      case providerConsts.PROVIDER_CHARGE: {
        return evcharge;
      }
      case providerConsts.PROVIDER_GREENSPOT: {
        return greenspot;
      }
      case providerConsts.PROVIDER_SONOL: {
        return sonol;
      }
      case providerConsts.PROVIDER_NETZER: {
        return netzer;
      }
      case providerConsts.PROVIDER_EV4U: {
        return Ev4u;
      }
      case providerConsts.PROVIDER_EDGE_CONTROL: {
        return EdgeControl;
      }
      case providerConsts.PROVIDER_SCALAEV: {
        return ScalaEv;
      }
      case providerConsts.PROVIDER_VIMORE: {
        return ViMore;
      }
      case providerConsts.PROVIDER_NOFAR: {
        return Nofar;
      }
      case providerConsts.PROVIDER_GREEMS: {
        return Greems;
      }
      case providerConsts.PROVIDER_TDSD: {
        return TDSD;
      }
      case providerConsts.PROVIDER_SEVENEV: {
        return SevenEv;
      }
      case providerConsts.PROVIDER_DORALURBAN: {
        return Doralurban;
      }
      case providerConsts.PROVIDER_LISHATECH: {
        return Lishatech;
      }
      case providerConsts.PROVIDER_ZENEV: {
        return ZenEv;
      }
      case providerConsts.PROVIDER_ENOVA: {
        return Enova;
      }
      case providerConsts.PROVIDER_INTEREV: {
        return InterEv;
      }
      case providerConsts.PROVIDER_EVEGDE: {
        return evedge;
      }

      case providerConsts.PROVIDER_EV_PLUS: {
        return EvPlus;
      }
      case providerConsts.PROVIDER_AMISRA_GREEN: {
        return AmisraGreen;
      }
      case providerConsts.PROVIDER_ADVICE: {
        return Advice;
      }
      case providerConsts.PROVIDER_EV_TECH: {
        return EvTech;
      }

      default: {
        return charge;
      }
    }
  };

  //Generally a good idea to move third-party integration into its own file,
  // even if you just include it here with an additional require.
  wazeNavigation = (addressInfo: AddressInfo) => {
    const wazeBaseUrl = "https://www.waze.com/";
    const wazeLanguage = this.getWazeLanguage();
    const wazeTo = "to=ll." + addressInfo.lat + "%2C" + addressInfo.lng;
    const wazeFrom = !this.props.userLocation
      ? ""
      : "&from=ll." +
        this.props.userLocation.lat +
        "%2C" +
        this.props.userLocation.lng;
    const wazeURL =
      wazeBaseUrl + wazeLanguage + "live-map/directions?" + wazeTo + wazeFrom;
    window.open(wazeURL, "_blank");
  };

  getWazeLanguage(): string {
    switch (this.props.browserLanguage) {
      case "ru":
      case "ar":
      case "he": {
        return this.props.browserLanguage + "/";
      }
      case "en-US":
      default: {
        return "";
      }
    }
  }

  googleMapsNavigation = (addressInfo: AddressInfo) => {
    const From = !this.props.userLocation
      ? ""
      : this.props.userLocation.lat + "%2C" + this.props.userLocation.lng;
    const googleMapsUrl =
      "https://www.google.com/maps/dir/" +
      From +
      "/" +
      addressInfo.lat +
      "%2C" +
      addressInfo.lng;

    window.open(googleMapsUrl, "_blank");
  };

  getCorrectStationIcon(): string {
    const { addressInfo } = this.props;
    switch (addressInfo.status) {
      case LayersFilters.UNKNOWN:
        return unknown_station_icon;
      case LayersFilters.AVAILABLE:
        return station_2_icon;
      case LayersFilters.BUSY:
        return busy_station_icon;
      case LayersFilters.INACTIVE:
        return inactive_station_icon;
      case LayersFilters.COMING_SOON:
        return comingSoon_station_icon;
      default:
        return station_2_icon;
    }
  }

  getConnectorImage = (connectorNumber: string): JSX.Element => {
    const connectorType = new ConnectorType();
    const COMBO = connectorType.COMBO;
    const PHASE = connectorType.PHASE;
    const TYPE_2 = connectorType.TYPE_2;
    const SCHUKO = connectorType.SCHUKO;

    switch (connectorNumber) {
      case COMBO:
        return <Combo_icon />;
      case PHASE:
        return <Phase_icon />;
      case TYPE_2:
        return <Type_2_img />;
      case SCHUKO:
        return <Schuko_icon />;
      default:
        return <Combo_icon />;
    }
  };

  getConnectorName = (connectorNumber: string): string => {
    const connectorType = new ConnectorType();
    const COMBO = connectorType.COMBO;
    const PHASE = connectorType.PHASE;
    const TYPE_2 = connectorType.TYPE_2;
    const SCHUKO = connectorType.SCHUKO;
    const CHADEMO = connectorType.CHADEMO;

    switch (connectorNumber) {
      case COMBO:
        return "combo";
      case PHASE:
        return "pahse";
      case TYPE_2:
        return "type2";
      case SCHUKO:
        return "schuko";
      case CHADEMO:
        return "chademo";
      default:
        return "combo";
    }
  };

  updatecConnectorTypes_1(): StationConnector[] {
    const connectorTypeClass = new ConnectorType();
    const { moreInfoData } = this.props;
    let combo = moreInfoData?.connectorTypes.filter(
      (connect) => connect.connectorType.toString() === connectorTypeClass.COMBO
    );
    let phase = moreInfoData?.connectorTypes.filter(
      (connect) => connect.connectorType.toString() === connectorTypeClass.PHASE
    );
    let type_2 = moreInfoData?.connectorTypes.filter(
      (connect) =>
        connect.connectorType.toString() === connectorTypeClass.TYPE_2
    );
    let schuko = moreInfoData?.connectorTypes.filter(
      (connect) =>
        connect.connectorType.toString() === connectorTypeClass.SCHUKO
    );
    let CHAdeMO = moreInfoData?.connectorTypes.filter(
      (connect) =>
        connect.connectorType.toString() === connectorTypeClass.CHADEMO
    );
    let other = moreInfoData?.connectorTypes.filter(
      (connect) => connect.connectorType.toString() === connectorTypeClass.OTHER
    );

    let connectorTypes: StationConnector[] = [];
    if (combo && combo.length > 0) {
      let cntr = 0;
      combo.map((cmb) => (cntr += cmb.connectorCounter));
      combo[0].counter = cntr;
      connectorTypes.push(combo[0]);
    }
    if (phase && phase.length > 0) {
      let cntr = 0;
      phase.map((cmb) => (cntr += cmb.connectorCounter));
      phase[0].counter = cntr;
      // phase[0].counter = phase.length;
      connectorTypes.push(phase[0]);
    }
    if (type_2 && type_2.length > 0) {
      let cntr = 0;
      type_2.map((cmb) => (cntr += cmb.connectorCounter));
      type_2[0].counter = cntr;
      // type_2[0].counter = type_2.length;
      connectorTypes.push(type_2[0]);
    }
    if (schuko && schuko.length > 0) {
      let cntr = 0;
      schuko.map((cmb) => (cntr += cmb.connectorCounter));
      schuko[0].counter = cntr;
      // schuko[0].counter = schuko.length;
      connectorTypes.push(schuko[0]);
    }
    if (CHAdeMO && CHAdeMO.length > 0) {
      let cntr = 0;
      CHAdeMO.map((cmb) => (cntr += cmb.connectorCounter));
      CHAdeMO[0].counter = cntr;
      // schuko[0].counter = schuko.length;
      connectorTypes.push(CHAdeMO[0]);
    }
    if (other && other.length > 0) {
      let cntr = 0;
      other.map((cmb) => (cntr += cmb.connectorCounter));
      other[0].counter = cntr;
      // schuko[0].counter = schuko.length;
      connectorTypes.push(other[0]);
    }
    return connectorTypes;
  }

  updatecConnectorTypes(): StationConnector[] {
    const connectorTypeClass = new ConnectorType();
    const { moreInfoData } = this.props;

    // If the old property exists, use it
    if (moreInfoData?.connectorTypes) {
      let combo = moreInfoData.connectorTypes.filter(
        (connect) =>
          connect.connectorType.toString() === connectorTypeClass.COMBO
      );
      let phase = moreInfoData.connectorTypes.filter(
        (connect) =>
          connect.connectorType.toString() === connectorTypeClass.PHASE
      );
      let type_2 = moreInfoData.connectorTypes.filter(
        (connect) =>
          connect.connectorType.toString() === connectorTypeClass.TYPE_2
      );
      let schuko = moreInfoData.connectorTypes.filter(
        (connect) =>
          connect.connectorType.toString() === connectorTypeClass.SCHUKO
      );
      let CHAdeMO = moreInfoData.connectorTypes.filter(
        (connect) =>
          connect.connectorType.toString() === connectorTypeClass.CHADEMO
      );
      let other = moreInfoData.connectorTypes.filter(
        (connect) =>
          connect.connectorType.toString() === connectorTypeClass.OTHER
      );

      let connectorTypes: StationConnector[] = [];
      if (combo && combo.length > 0) {
        let cntr = 0;
        combo.forEach((cmb) => {
          cntr += cmb.connectorCounter;
        });
        combo[0].counter = cntr;
        connectorTypes.push(combo[0]);
      }
      if (phase && phase.length > 0) {
        let cntr = 0;
        phase.forEach((cmb) => {
          cntr += cmb.connectorCounter;
        });
        phase[0].counter = cntr;
        connectorTypes.push(phase[0]);
      }
      if (type_2 && type_2.length > 0) {
        let cntr = 0;
        type_2.forEach((cmb) => {
          cntr += cmb.connectorCounter;
        });
        type_2[0].counter = cntr;
        connectorTypes.push(type_2[0]);
      }
      if (schuko && schuko.length > 0) {
        let cntr = 0;
        schuko.forEach((cmb) => {
          cntr += cmb.connectorCounter;
        });
        schuko[0].counter = cntr;
        connectorTypes.push(schuko[0]);
      }
      if (CHAdeMO && CHAdeMO.length > 0) {
        let cntr = 0;
        CHAdeMO.forEach((cmb) => {
          cntr += cmb.connectorCounter;
        });
        CHAdeMO[0].counter = cntr;
        connectorTypes.push(CHAdeMO[0]);
      }
      if (other && other.length > 0) {
        let cntr = 0;
        other.forEach((cmb) => {
          cntr += cmb.connectorCounter;
        });
        other[0].counter = cntr;
        connectorTypes.push(other[0]);
      }
      return connectorTypes;
    }
    // Otherwise, use the new API property (connectorTypesArr) which is an array of strings.
    else if (moreInfoData?.connectorTypesArr) {
      // Count occurrences of each connector type:
      const counts = moreInfoData.connectorTypesArr.reduce(
        (acc: { [key: string]: number }, curr: string) => {
          acc[curr] = (acc[curr] || 0) + 1;
          return acc;
        },
        {}
      );
      // Convert the counts to an array of StationConnector objects.
      const connectorTypes: StationConnector[] = [];
      for (let type in counts) {
        connectorTypes.push({
          connectorType: parseInt(type, 10), // Convert string key to a number
          counter: counts[type],
          // Provide default values for the other required properties:
          connectorTypesArr: [],
          daysOfWeek: 0,
          endTime: "",
          includingVat: false,
          power: 0,
          price: 0,
          priceType: 0,
          refId: "",
          reservation: false,
          startTime: "",
          connectorCounter: 0,
        });
      }
      return connectorTypes;
    }

    return [];
  }

  InfoTabValueChanged = (
    event: React.ChangeEvent<{}>,
    newValue: string
  ): void => {
    this.setState({ tabValue: newValue });
  };
}

interface IconMapProps {
  lat: number;
  lng: number;
  addressInfo: AddressInfo;
  getMoreInfoStation: Function;
  closeAllPopups: boolean;
  selectedStation?: AddressInfo;
  browserLanguage: BrowserLanguage;
  userLocation?: Coordinates;
  onClickStation: Function;
  stringsFromServer: StringsData;
  moreInfoData?: MoreInfoData;
  showMoreInfoPopup: () => void;
  providersArr?: any[];
  price?: number;
  totalInLocation?: number;
  visibleInLocation?: number;
  availableInLocation?: number;
  availableStationsNearbyCount?: number;
}

interface IconMapState {
  tooltipType: "tooltip" | "popup";
  open: boolean;
  selectedAddressInfo?: AddressInfo;
  portalView: boolean;
  tabValue: string;
  showMoreInfoPopup?: () => void;
}

interface Station {
  id: string;
  mac: string;
  code: string;
  name: string;
  status: string;
  connectors: {
    standard: string;
    powerType: string;
    format: string;
    maxPower: number;
  }[];
}

export default IconMap;
